function countdown(element, minutes, seconds) {
  // set time for the particular countdown
  var time = minutes * 60 + seconds;

  var checkClassInterval = setInterval(function () {
    if (
      document.getElementsByClassName("line-item__content-wrapper").length > 0
    ) {
      clearInterval(checkClassInterval);
      var interval = setInterval(function () {
        var el = document.getElementById(element);
        // if the time is 0 then end the counter
        if (time <= 0) {
          var text = "<b>Order Now</b>";
          var ef = document.getElementsByClassName("notch")[0];
          if (ef) ef.innerHTML = text;
          clearInterval(interval);
          return;
        }
        var minutes = Math.floor(time / 60);
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = time % 60;
        if (seconds < 10) seconds = "0" + seconds;
        var text = minutes + ":" + seconds;
        if (el) el.innerHTML = text;
        time--;
      }, 1000);
    }
  }, 1000);
}

document.addEventListener("DOMContentLoaded", () => {
  countdown("clock", 10, 0);
  var count = document.getElementById("cart__count");
  var counttext = 1;
  if (count) {
    count.innerHTML = counttext;
  }
});

/* shipping protection */
(function() {
  const VARIANT_ID = '51073500053720';
  const COOKIE_NAME = 'sp_pref';
  const UPDATE_DELAY = 300;
  const RETRY_DELAY = 100;
  const DUPLICATE_REMOVE_DELAY = 200;
  const REFRESH_CHECK_DELAY = 50;
  const HANDLER_ATTACH_DELAY = 100;
  const STATE_CHECK_INTERVAL = 800;
  const INITIAL_FORCE_DELAY = 500;
  
  let isUpdating = false;
  let currentState = null;

  function setCookie(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
    console.log('💾 Cookie:', value);
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  function getCorrectState() {
    if (currentState !== null) return currentState;
    
    const savedPref = getCookie(COOKIE_NAME);
    
    if (savedPref === null) {
      console.log('📝 First visit - default TRUE');
      currentState = true;
      setCookie(COOKIE_NAME, 'true');
      return true;
    }
    
    currentState = savedPref === 'true';
    return currentState;
  }

  function updateState(newState) {
    currentState = newState;
    setCookie(COOKIE_NAME, newState);
  }

  function updateToggleUI(state) {
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    toggle.setAttribute('data-checked', state);
    toggle.style.backgroundColor = state ? '#4CAF50' : '#ccc';
    
    const slider = toggle.querySelector('.sp-custom-slider');
    if (slider) {
      slider.style.transform = state ? 'translateX(24px)' : 'translateX(0px)';
    }
  }

  function isProtectionItem(item) {
    return String(item.variant_id) === VARIANT_ID || 
           String(item.id) === VARIANT_ID ||
           (item.title && item.title.toLowerCase().includes('versand'));
  }

  function finishUpdating() {
    setTimeout(() => { isUpdating = false; }, UPDATE_DELAY);
  }

  function forceToggleState() {
    updateToggleUI(getCorrectState());
  }

  function removeAllProtections() {
    console.log('🗑️ Removing...');
    isUpdating = true;
    
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const protectionItems = cart.items.filter(isProtectionItem);
        
        if (protectionItems.length === 0) {
          isUpdating = false;
          return;
        }
        
        return Promise.all(
          protectionItems.map(item => 
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            })
          )
        );
      })
      .then(finishUpdating)
      .catch(e => {
        console.error('❌ Error:', e);
        finishUpdating();
      });
  }

  function addProtection() {
    isUpdating = true;
    
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const existingProtections = cart.items.filter(isProtectionItem);
        
        if (existingProtections.length > 0) {
          return Promise.all(
            existingProtections.map(item => 
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              })
            )
          ).then(() => new Promise(resolve => setTimeout(resolve, DUPLICATE_REMOVE_DELAY)));
        }
      })
      .then(() => 
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
        })
      )
      .then(r => {
        if (!r.ok) {
          return r.text().then(text => {
            console.error('Add failed:', text);
            throw new Error('Add failed');
          });
        }
        return r.json();
      })
      .then(finishUpdating)
      .catch(e => {
        console.error('❌ Error:', e);
        finishUpdating();
      });
  }

  function handleToggleClick(e) {
    e?.preventDefault();
    e?.stopPropagation();
    
    if (isUpdating) {
      return;
    }
    
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    const current = toggle.getAttribute('data-checked') === 'true';
    const newState = !current;
    
    updateState(newState);
    updateToggleUI(newState);
    
    newState ? addProtection() : removeAllProtections();
  }

  function attachClickHandler() {
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) {
      setTimeout(attachClickHandler, RETRY_DELAY);
      return;
    }
    
    toggle.removeEventListener('click', handleToggleClick);
    toggle.removeEventListener('touchend', handleToggleClick);
    toggle.addEventListener('click', handleToggleClick, false);
    toggle.addEventListener('touchend', handleToggleClick, false);
  }

  // Cart refresh listeners
  ['cart:refresh', 'cart:updated', 'cart:update', 'cart-drawer:refresh'].forEach(eventName => {
    document.addEventListener(eventName, () => {
      if (!isUpdating) {
        setTimeout(forceToggleState, REFRESH_CHECK_DELAY);
        setTimeout(attachClickHandler, HANDLER_ATTACH_DELAY);
      }
    });
  });

  // State monitoring
  setInterval(() => {
    if (isUpdating) return;
    
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    const currentAttr = toggle.getAttribute('data-checked');
    const shouldBe = String(getCorrectState());
    
    if (currentAttr !== shouldBe) {
      forceToggleState();
    }
    
    if (!toggle.onclick && !toggle.hasAttribute('data-handler-attached')) {
      attachClickHandler();
    }
  }, STATE_CHECK_INTERVAL);

  function initToggle() {
    
    const toggle = document.getElementById('sp-custom-toggle');
    
    if (!toggle) {
      setTimeout(initToggle, RETRY_DELAY);
      return;
    }
    
    const shouldBeChecked = getCorrectState();
    
    forceToggleState();
    attachClickHandler();
    
    setTimeout(forceToggleState, INITIAL_FORCE_DELAY);
    
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const isInCart = cart.items.filter(isProtectionItem).length > 0;
        
        if (shouldBeChecked && !isInCart) {
          addProtection();
        } else if (!shouldBeChecked && isInCart) {
          removeAllProtections();
        }
        
      })
      .catch(e => console.error('❌ Error:', e));
  }

  initToggle();
})();